export const DEFAULT_COURSE_ID = "laishi-grammar";

/**
 * 解析后端 API 地址。
 * - 优先用 NEXT_PUBLIC_API_BASE 环境变量（部署时固定）
 * - 浏览器端：相对路径 /api，经 next.config rewrites 反代到后端，Cookie 自动同源携带
 * - 服务端（SSR）：直连后端 localhost:8000，登录 cookie 由 lib/api 的 serverAuthHeaders 显式附加
 */
export function resolveApiBase(): string {
  if (process.env.NEXT_PUBLIC_API_BASE) {
    return process.env.NEXT_PUBLIC_API_BASE;
  }
  if (typeof window !== "undefined") {
    return "/api";
  }
  // 服务端：优先 BACKEND_INTERNAL_URL（与 next.config / api-stream 一致），默认本机后端
  return `${process.env.BACKEND_INTERNAL_URL || "http://localhost:8000"}/api`;
}